module.exports = __webpack_public_path__ + "img/QuantifiedESG_Logo_v3_Basic.08df8abd.png";